/**
 * @Description: 
 * @Version: 2.5.2
 * @Autor: jzt
 * @Date: 2023-03-15 10:00:00
 * @LastEditors: jzt
 * @LastEditTime: 2023-03-29 17:30:00
 */
import Vue from "vue";
import Router from "vue-router";
import { loginAction } from "./modules/loginRouter";
import { websiteRouter } from "./modules/websiteRouter";
import { userRouter } from "./modules/userRouter";
import { onlypageRouter } from "./modules/onlypageRouter";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    
    // 登录路由
    ...loginAction,

    // 官网路由
    ...websiteRouter,

    // 用户路由
    ...userRouter,

    // 独显路由
    ...onlypageRouter,

  ]
});

export default router;
router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title;
  }

  let token = localStorage.getItem("token");

  if(to.name == 'loginIndex' && !token) {
    localStorage.setItem('loginBackUrl',from.fullPath);
  }

  if(to.path=='/' || to.path.search('zscloud')==1) {
    return next();
  } else {
    if(to.name == 'getToken' && !token) {
      return next();
    } else if (to.name !== 'loginIndex' && !token) {
      return next({ name: 'loginIndex' });
    } else if (to.name == 'loginIndex' && token) {
      return next({ name: 'website' });
    } else {
      return next();
    }
  }
});




// WEBPACK FOOTER //
// ./src/router/index.js